@if (visible) {
  <div class="credit-chip" [class.tier-healthy]="tier === creditBalanceTier.Healthy" [class.tier-low]="tier === creditBalanceTier.Low"
    [class.tier-critical]="tier === creditBalanceTier.Critical" [matMenuTriggerFor]="consumptionMenu" [matTooltip]="'Credits remaining' | translate">
    <mat-icon>toll</mat-icon>
    <span class="bal">{{ balance | number }}</span>
    <span>{{ 'credits' | translate }}</span>
  </div>
}
<mat-menu #consumptionMenu="matMenu" class="credit-chip-menu" xPosition="before">
  <app-consumption-popover></app-consumption-popover>
</mat-menu>
